"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledFooter = styled_components_1.default.footer `
	width: 100%;
	display: flex;
	align-items: flex-end;	

	span {
        position: relative;
        bottom: 0;
        height: 30px;
        font-size: ${({ theme }) => theme.smallFontSize};
		color: ${({ theme }) => `${theme.gray4}`};
		text-align: left;
		font-weight: ${({ theme }) => `${theme.fontNormal}`};
		margin: 20px 0 0 20px;
		outline: none;
		letter-spacing: 0;
		visibility: hidden; //KF requested the Footer be hidden to not distract user. CKFSR-969
	}
`;
const Footer = () => {
    return (react_1.default.createElement(StyledFooter, null,
        react_1.default.createElement("span", { role: "contentinfo", "aria-label": `Version ${process.env.REACT_APP_VERSION}`, "aria-hidden": false })));
};
exports.Footer = Footer;
